import { FC } from 'react';
import { RunningActivitiesContainer } from './RunningActivities.style';

export const RunningActivitiesLoading: FC = () => (
	<RunningActivitiesContainer
		role="status"
		className="w-full animate-pulse divide-y divide-gray-200 rounded-3xl border border-gray-200 px-4 shadow dark:divide-gray-700 dark:border-gray-700"
	>
		<div className="flex items-center justify-between gap-4 py-3">
			<div className="h-5 w-1/2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
			<div className="h-5 w-1/2 rounded-full bg-gray-300 dark:bg-gray-600"></div>
		</div>
		<div className="activities__container">
			{Array.from(new Array(2)).map((e, i) => {
				return (
					<div className="p-4" key={i}>
						<div className="flex items-center justify-between" key={i}>
							<div className="flex items-center justify-start gap-4">
								<div className="h-16 w-16 rounded-full bg-gray-300 dark:bg-gray-700"></div>
								<div className="flex flex-col gap-2">
									<div className="h-2.5 w-32 rounded bg-gray-300 dark:bg-gray-700"></div>
									<div className="h-2.5 w-28 rounded-2xl bg-gray-300 dark:bg-gray-700"></div>
								</div>
							</div>
							<div className="h-3 w-28 rounded-full bg-gray-300 dark:bg-gray-700"></div>
						</div>
						<div className="mt-2 flex w-full items-center justify-between px-2">
							<div className="w-5/6">
								<div className="mb-2.5 h-2 max-w-[480px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
								<div className="mb-2.5 h-2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
								<div className="mb-2.5 h-2 max-w-[460px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
								<div className="h-2 max-w-[360px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
							</div>
							<div className="h-8 w-8 rounded-full bg-gray-300 dark:bg-gray-700"></div>
						</div>
					</div>
				);
			})}
		</div>
	</RunningActivitiesContainer>
);
